import _ from "lodash"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { fetchSpecialtiesAsync } from "../../features/specialty/state/specialtyActions"
import { fetchAllUsersAsync } from "../../features/users/state/usersActions"
import { RoutePaths } from "../../app/routes/Routes"
import Breadcrumbs from "../../shared/components/ui/Breadcrumbs"
import TeamNewForm from "../../features/teamNew/components/TeamNewForm"

const TeamsNewPage: React.FC = (): JSX.Element => {
  const { t } = useTranslation(["shared", "team"])
  const dispatch = useDispatch()
  const fetchSpecialties = () => dispatch(fetchSpecialtiesAsync())
  const fetchUsers = () => dispatch(fetchAllUsersAsync())

  useEffect(() => {
    fetchSpecialties()
    fetchUsers()
  }, [])

  return (
    <div>
      <Breadcrumbs
        breadcrumbs={[
          {
            pageTitle: t("shared:teams"),
            href: RoutePaths.TEAMS
          },
          {
            pageTitle: t("team:addANewTeam")
          }
        ]}
      />
      <TeamNewForm />
    </div>
  )
}

export default TeamsNewPage
